import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="min-h-screen grain grid place-items-center px-5">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center card-soft"
        data-testid="payment-cancel"
      >
        <XCircle className="h-12 w-12 mx-auto text-muted-foreground" />
        <h1 className="mt-6 font-heading text-3xl tracking-tight">{t("checkout.cancelTitle")}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {t("checkout.cancelBody")}
        </p>
        <div className="mt-8 flex flex-col gap-2">
          <Button
            className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90"
            onClick={() => navigate("/dashboard")}
            data-testid="cancel-dashboard"
          >
            {t("checkout.goToDashboard")} <ArrowRight className="h-4 w-4 ml-1" />
          </Button>
          <Button variant="ghost" onClick={() => navigate("/company-formation")} data-testid="cancel-services">
            {t("common.browseAll")}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
